import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import { cartorioKey, tokenKey } from "../Utils/localStorageKeys";
import api from "../Services/api";
import { app_base_url, app_server } from "../Utils/baseUrl";

export interface ICartorio {
  ID: number;
  NOME: string;
  CPF_CNPJ: string;
  EMAIL: string | null;
  FONE: string | null;
  WHATS: string | null;
  SENHA: string | null;
}

interface ICartorioContextData {
  cartorioIsLogged: boolean;
  cartorio: ICartorio;
  signInCartorio(cpf_cnpj: string, senha: string, hash: boolean): Promise<void>;
  getCartorio(id: number): Promise<void>;
  signOut(): void;

  handleSetCartorio(n_cartorio: ICartorio): void;
  checarToken(): Promise<void>;
  validateToken(): Promise<void>;
}

interface ICartorioProviderProps {
  children: ReactNode;
}

const CartorioContext = createContext({} as ICartorioContextData);

function CartorioProvider({ children }: ICartorioProviderProps) {
  const [cartorioIsLogged, setCartorioIsLogged] = useState(false);
  const [cartorio, setCartorio] = useState({} as ICartorio);

  function signOut() {
    localStorage.removeItem(cartorioKey);
    localStorage.removeItem(tokenKey);
    setCartorio({} as ICartorio);
    setCartorioIsLogged(false);
    window.location.href = `${app_server}${app_base_url}/cartorio`;
  }
  useEffect(() => {
    if (!cartorioIsLogged) checarToken();
  }, [cartorio.ID]);
  async function signInCartorio(
    cpf_cnpj: string,
    senha: string,
    hash: boolean
  ) {
    if (!hash) {
      const { data } = await api.post("/cartorio/signIn", {
        cpf_cnpj,
        senha,
      });
      setCartorio(data.cartorio);
      localStorage.setItem(tokenKey, data.token);
      localStorage.setItem(cartorioKey, JSON.stringify(data.cartorio));
      setCartorioIsLogged(true);
    } else {
      const { data } = await api.post("/cartorio/signInHash", {
        cpf_cnpj,
        senha,
      });
      setCartorio(data.cartorio);
      localStorage.setItem(tokenKey, data.token);
      localStorage.setItem(cartorioKey, JSON.stringify(data.cartorio));
      setCartorioIsLogged(true);

      api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    }
  }

  function handleSetCartorio(n_cartorio: ICartorio) {
    setCartorio(n_cartorio);
    localStorage.setItem(cartorioKey, JSON.stringify(n_cartorio));
  }

  async function getCartorio(id: number) {
    try {
      const { data } = await api.get(`/cartorio/por-id/${id}`);
      setCartorio(data);
    } catch (error) {
      throw error;
    }
  }

  async function validateToken() {
    const getCartorio = localStorage.getItem(cartorioKey);

    try {
      if (getCartorio) {
        setCartorio(JSON.parse(getCartorio));

        if (cartorio.SENHA) {
          await signInCartorio(cartorio.CPF_CNPJ, cartorio.SENHA, true);
        }
      }
    } catch (error) {
      signOut();
    }
  }

  async function checarToken() {
    try {
      const token = localStorage.getItem(tokenKey);
      const getCartorio = localStorage.getItem(cartorioKey);
      if (token && getCartorio) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        await api.get("/checa-token");
        setCartorio(JSON.parse(getCartorio));
        setCartorioIsLogged(true);
      }
    } catch (error) {
      //Se estiver invalido o token eu valido ele
      if (cartorioIsLogged) {
        validateToken();
      } else {
        signOut();
        throw "Token Inválido!";
      }
    }
  }

  return (
    <CartorioContext.Provider
      value={{
        cartorio,
        cartorioIsLogged,
        signInCartorio,
        getCartorio,
        signOut,

        handleSetCartorio,
        checarToken,
        validateToken,
      }}
    >
      {children}
    </CartorioContext.Provider>
  );
}

function useCartorio() {
  const context = useContext(CartorioContext);

  return context;
}

export { CartorioProvider, useCartorio };
